import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { currentSubscription, disablePush, enablePush, pushSupported } from "@/lib/push";

export function usePush() {
  const supported = pushSupported();
  const [subscribed, setSubscribed] = useState(null);
  const [permission, setPermission] = useState(supported ? Notification.permission : "unsupported");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supported) return;
    currentSubscription().then((sub) => {
      setSubscribed(!!sub);
      if (sub) api.post("/push/subscribe", sub.toJSON()).catch(() => {});
    });
  }, [supported]);

  const run = useCallback(async (fn, ok) => {
    setBusy(true);
    try {
      await fn();
      setSubscribed(!!(await currentSubscription()));
      toast.success(ok);
    } catch (e) {
      toast.error(e?.response ? formatError(e) : e.message);
    } finally {
      setPermission(Notification.permission);
      setBusy(false);
    }
  }, []);

  const enable = () => run(enablePush, "Notifiche push attivate su questo dispositivo");
  const disable = () => run(disablePush, "Notifiche push disattivate su questo dispositivo");
  const test = () => run(() => api.post("/push/test"), "Notifica di prova inviata");
  return { supported, subscribed, permission, busy, enable, disable, test };
}
